/*
*
* File JS componente Archive Filters
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './archive-events-filter.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const archiveEventsFilters = () => {

    let years = document.querySelectorAll('.event_years .event_year');

    if (!years) return;

    years.forEach(el => {
        el.addEventListener('click', function() {

            let year = this.getAttribute('data-value');
            console.log(year);
            let currLocation = window.location.href.split(/([0-9]{4})/)[0];

            if (year == '-1') {
                window.location = currLocation;
            } else if (year) { 
                window.location = `${currLocation}${year}`; // redirect
            } else {
                return false;
            }
        })
    })
}

export default archiveEventsFilters;

//--------------------------------------------------------------------//